import { Select } from './Select';

// TODO: in v9, move styled() from Select.jsx to here
export var StyledSelect = Select;